export default [
  { label: 'Price Reduced', value: 'price-reduced' },
  { label: 'Newly Listed', value: 'newly-listed' },
  { label: 'In Forclosure', value: 'in-forclosure' },
  { label: 'Bank-Owned', value: 'bank-owned' },
];

export const otherStatuses = [
  { label: 'Virtual Tours', value: 'virtual-tours' },
  { label: 'HOA', value: 'hoa' },
];
